import { render, staticRenderFns } from "./DeleteOfferItemPriceManipulations.vue?vue&type=template&id=c4d6f4fc&scoped=true"
import script from "./DeleteOfferItemPriceManipulations.vue?vue&type=script&lang=ts"
export * from "./DeleteOfferItemPriceManipulations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d6f4fc",
  null
  
)

export default component.exports